export function header() {
    gsap.timeline({
        scrollTrigger: {
            trigger: ".section-hero",
            start: "top top",
            end: "center top",
            scrub: true,
            once: false,
        },
    })
        .to(
            ".section-hero .copy-wrapper h1",
            {
                opacity: 0,
            },
            "<"
        )
        .to(
            ".section-hero .copy-wrapper p",
            {
                opacity: 0,
            },
            ">-0.25"
        )
        .to(
            ".section-hero ul.btn-list li",
            {
                opacity: 0,
                stagger: 0.15,
            },
            ">-0.25"
        )
}
